// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 804
// module chunks = 0